module.exports = __webpack_public_path__ + "img/Predicine_DIRECT_Logo.ai.75202a24.png";